import Styles from '../Search.module.scss'
import { connectInfiniteHits } from 'react-instantsearch-dom'
import { ResultItemArticle } from './ResultItemArticle'
import { ResultItemProject } from './ResultItemProject'
import { ViewType } from '../SearchList/SearchList'
import { ListResultItem } from './ListResultItem/ListResultItem'
import { Text } from 'blaze-ui/Text/Text'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface Props {
  hits: any[]
  viewType: ViewType
}

export const SearchResults = ({ hits, viewType }: Props) => {
  const { isTabletPortrait, isMobile } = useResponsiveDesign()

  if (viewType === 'List')
    return (
      <>
        <div className={Styles.itemsList}>
          {!isMobile && (
            <div className={Styles.listHeader}>
              <Text variant="placeholder">Name</Text>

              {<Text variant="placeholder">Last Modified</Text>}
              {!isTabletPortrait && <Text variant="placeholder">Owner</Text>}
            </div>
          )}
          {hits.map((item, index) => {
            return <ListResultItem key={index} item={item} />
          })}
        </div>
      </>
    )

  return (
    <>
      <div className={Styles.itemsGrid}>
        {hits.map((item, index) => {
          if (item.file_type === 'project') return <ResultItemProject key={index} item={item} />

          return <ResultItemArticle key={index} item={item} />
        })}
      </div>
    </>
  )
}

export const ConnectedSearchResults = connectInfiniteHits(SearchResults)
